import { Dispatch } from 'store/store';
import { AnyAction } from '@reduxjs/toolkit';
import { getGlobalWindowVariables } from 'utils/globalWindowVariables';
import { LoggingService } from '@instinet-analytics/core-lib';
import { actionsBlacklist } from 'store/devToolsConfig';
import Services from 'store/Services';
import { actionSanitizers } from 'app/store/appStore.ts';

const blacklist = actionsBlacklist.join('|');

export const middleware = (services: Services) => [
    logActionsMiddleware(services.loggingService),
];

function logActionsMiddleware(loggingService: LoggingService) {
    return () => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        // update the state
        next(action);

        if (!action.type) {
            return;
        }

        if (action.type.match(blacklist)) {
            return;
        }

        if (getGlobalWindowVariables().suppressLoggingStoreActions) {
            return;
        }

        loggingService.debug('store', action.type, sanitizePayload(action));
    };
}

function sanitizePayload(action: AnyAction): AnyAction {
    let sanitizedAction = action;
    for (const actionSanitizer of actionSanitizers) {
        sanitizedAction = actionSanitizer(sanitizedAction, 0);
    }
    return sanitizedAction;
}
